import get from 'lodash/get';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Row, Col, FormGroup } from 'reactstrap';
import us from 'us';

import InputField from '../input-field';
import { StateSelector } from '../inputs';

import { LocationLookup } from './location-lookup';

interface FormAddressProps {
  id: string;
  className?: string;
  title?: string;
  required?: boolean;
  fieldName: string;
  secondaryAddress?: boolean;
}

export default function FormAddress({
  id,
  className,
  title,
  fieldName,
  secondaryAddress,
  required = false,
}: FormAddressProps) {
  const buildId = (suffix: string) => `${id || ''}-${suffix}`;

  const fields = {
    street: `${fieldName}.street`,
    street2: secondaryAddress ? `${fieldName}.street2` : '',
    city: `${fieldName}.city`,
    zip: `${fieldName}.zip`,
    state: `${fieldName}.state`,
    country: `${fieldName}.country`,
  };
  const { setValue, register } = useFormContext();

  const handleLocLookup = ({
    street,
    city,
    state,
    zip,
  }: {
    street: string;
    city: string;
    state: string;
    zip: string;
  }) => {
    const stateName = state && get(us.lookup(state), 'name');
    setValue(fields.street, street);
    setValue(fields.city, city);
    setValue(fields.state, stateName);
    setValue(fields.zip, zip);
  };

  return (
    <div className={className}>
      <div className="flex-lg-nowrap align-items-center">
        {title && <h2 className="mb-2">{title}</h2>}
        <LocationLookup
          className="flex-grow-1 w-auto mt-1 mb-2"
          id={buildId('search')}
          onLookup={handleLocLookup}
        />
      </div>
      <Row>
        <Col sm={6}>
          <FormGroup>
            <InputField
              required={required}
              id={buildId('street')}
              name={fields.street}
              label="Address"
              aria-label="Address"
              {...register}
            />
          </FormGroup>
        </Col>
        {secondaryAddress && (
          <Col sm={6}>
            <FormGroup>
              <InputField
                id={buildId('street2')}
                label="Address line 2"
                aria-label="Address line 2"
                {...register}
                name={fields.street2}
              />
            </FormGroup>
          </Col>
        )}
      </Row>
      <Row>
        <Col sm={12} xl={6}>
          <FormGroup>
            <InputField
              required={required}
              label="City"
              id={buildId('city')}
              name={fields.city}
              aria-label="City"
              {...register}
            />
          </FormGroup>
        </Col>
        <Col sm={6} xl={4}>
          <FormGroup>
            <StateSelector
              id={buildId('state')}
              name={fields.state}
              label="State"
              {...register}
              required={required}
            />
          </FormGroup>
        </Col>
        <Col sm={6} xl={2}>
          <FormGroup>
            <InputField
              required={required}
              label="ZIP Code"
              id={buildId('zip')}
              name={fields.zip}
              aria-label="ZIP Code"
              maxLength={10}
              {...register}
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
}
